import { Component, OnInit, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {PanelOutputGroup} from '../../../core/models/panel-output-group';
import {PanelOutputLockingStatus} from '../../../core/models/panel-output-locking-status';
import {PanelOutputType} from '../../../core/models/panel-output-type';
import {PanelOutput} from '../../../core/models/panel-output.interface';
import { SharedState } from '../../../core/store/shared/shared.state';
import { SelectPanelOutput, ResetCommandsMessages } from '../../../core/store/panel-outputs/panel-outputs.actions';
import { PanelOutputsStateSelectors } from '../../../core/store/panel-outputs/panel-outputs.selectors';

@Component({
  selector: 'app-panel-output-item',
  templateUrl: './panel-output-item.component.html',
  styleUrls: ['./panel-output-item.component.scss']
})
export class PanelOutputItemComponent implements OnInit {
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;
  @Select(PanelOutputsStateSelectors.selectedOutput) selectedOutput$: Observable<PanelOutput>;

  @Input() output: PanelOutput;
  @Input() outputGroup: PanelOutputGroup;
  @Input() displayColumns: { code: string, label: string }[];

  isSelected: boolean;
  outputStatus = PanelOutputLockingStatus;
  outputType = PanelOutputType;
  groupName: string;

  constructor(private readonly store: Store) { }

  ngOnInit() {
    if (this.outputGroup) {
      this.groupName = this.outputGroup.description;
    }
    this.selectedOutput$.subscribe((selectedOutput: PanelOutput) => {
      if (selectedOutput) {
        this.isSelected = (
          this.output.id === selectedOutput.id
        );
      } else {
        this.isSelected = false;
      }
    });
  }

  handleClick(output: PanelOutput) {
    this.resetMessages();
    this.store.dispatch(new SelectPanelOutput(output));
  }

  resetMessages() {
    this.store.dispatch(new ResetCommandsMessages());
  }

}
